const BrandLogo = ({ brand }: { brand: string }) => {
  switch (brand) {
    case "OLAY":
      return (
        <div className="flex flex-col items-center">
          <span className="text-2xl md:text-3xl lg:text-4xl font-serif tracking-[0.2em] text-black">
            OLAY
          </span>
          <svg className="w-16 h-2 mt-1" viewBox="0 0 60 8">
            <path
              d="M0 4 Q30 8 60 4"
              fill="none"
              stroke="black"
              strokeWidth="1.5"
            />
          </svg>
        </div>
      );
    case "Dove":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-serif italic text-black tracking-normal">
          Dove
        </span>
      );
    case "ORIFLAME":
      return (
        <div className="flex flex-col items-center">
          <span className="text-xl md:text-2xl lg:text-3xl font-light tracking-[0.3em] text-black">
            ORIFLAME
          </span>
          <span className="text-[8px] md:text-[10px] tracking-[0.4em] text-black font-light mt-0.5">
            SWEDEN
          </span>
        </div>
      );
    case "COSRX":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-black">
          COSRX
        </span>
      );
    case "CeraVe":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-semibold text-black">
          CeraVe
        </span>
      );
    case "TheOrdinary":
      return (
        <div className="flex items-baseline gap-1">
          <span className="text-xl md:text-2xl lg:text-3xl font-light text-black">
            The
          </span>
          <span className="text-xl md:text-2xl lg:text-3xl font-bold text-black">
            Ordinary.
          </span>
        </div>
      );
    case "UNCOVER":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-black tracking-wide text-black">
          UNCOVER
        </span>
      );
    case "Anua":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-serif text-black tracking-wider">
          Anua
        </span>
      );
    case "NIVEA":
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-bold italic text-black tracking-normal">
          NIVEA
        </span>
      );
    case "SKIN1004":
      return (
        <span className="text-xl md:text-2xl lg:text-3xl font-medium tracking-[0.4em] text-black">
          SKIN1004
        </span>
      );
    default:
      return (
        <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-black">
          {brand}
        </span>
      );
  }
};

const brands = [
  "OLAY",
  "Dove",
  "ORIFLAME",
  "COSRX",
  "CeraVe",
  "TheOrdinary",
  "UNCOVER",
  "Anua",
  "NIVEA",
  "SKIN1004",
];

export function BrandShowcase() {
  // Duplicate brands twice for seamless loop
  const duplicatedBrands = [...brands, ...brands];

  return (
    <section className="w-full py-8 bg-gradient-to-r from-blush/30 via-card to-blush/30 overflow-hidden border-y border-primary/10">
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
      <div className="relative">
        <div
          className="inline-flex items-center gap-12 md:gap-16 lg:gap-20"
          style={{
            animation: "marquee 30s linear infinite",
            willChange: "transform",
          }}
        >
          {duplicatedBrands.map((brand, index) => (
            <div
              key={`${brand}-${index}`}
              className="flex-shrink-0 flex items-center gap-8 md:gap-12"
            >
              <BrandLogo brand={brand} />
              <span className="text-black/30 text-xl">|</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
